import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./report-type-form.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./report-type-form.component.scss?ngResource";
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { UcFirstPipe } from "ngx-pipes";
import { ReportCriteriaConst } from "../report-criteria-form/report-criteria-constants";
import { ReportService } from "../report.service";
import { SharedConstants } from "../../../constants/shared.constants";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../models/crud-operation-enum.model";
import { AutoUnsub } from "../../../decorators/autounsub.decorator";
let ReportTypeFormComponent = class ReportTypeFormComponent {
    formBuilder;
    appController;
    changeDetectorRefs;
    reportService;
    ucFirst;
    reportList;
    reportListByGroupName;
    selectedReport;
    reportGroupType;
    reportTypeForm;
    showing = new EventEmitter();
    selectReportGroup = ReportCriteriaConst.SELECT_REPORT_GROUP;
    selectReport = ReportCriteriaConst.SELECT_REPORT;
    criteriaFieldValueError = SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION;
    selectReportFielName = ReportCriteriaConst.SELECT_REPORT_FIELD_NAME;
    selectReportGroupFieldName = ReportCriteriaConst.SELECT_REPORT_GROUP_FIELD_NAME;
    reportGroupControl = ReportCriteriaConst.REPORT_GROUP_CONTROL;
    reportIdControl = ReportCriteriaConst.REPORT_ID_CONTROL;
    uploadReportControl = ReportCriteriaConst.UPLOAD_REPORT_CONTOL;
    canDownloadInPortalControl = ReportCriteriaConst.REPORT_AVAILABLE_IN_PORTAL_CONTROL;
    uploadReportlBL = ReportCriteriaConst.UPLOAD_REPORT;
    canDownloadInPortalLabel = ReportCriteriaConst.AVAILABLE_IN_PORTAL_LABEL_REPORT;
    reportGroupNameMap;
    getReportGroupSubscription;
    get reportId() {
        return this.reportTypeForm.get(ReportCriteriaConst.REPORT_ID_CONTROL);
    }
    get reportCriteria() {
        return this.reportTypeForm.get(ReportCriteriaConst.REPORT_CRITERIA_CONTROL);
    }
    get reportCriteriaFgp() {
        return this.reportTypeForm.get(ReportCriteriaConst.REPORT_CRITERIA_CONTROL);
    }
    get reportGroup() {
        return this.reportTypeForm.get(ReportCriteriaConst.REPORT_GROUP_CONTROL);
    }
    reportCriteriaRow = {};
    reportDataInfoRow = {};
    constructor(formBuilder, appController, changeDetectorRefs, reportService, ucFirst) {
        this.formBuilder = formBuilder;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.reportService = reportService;
        this.ucFirst = ucFirst;
    }
    ngOnInit() {
        this.pageInit();
    }
    pageInit() {
        this.reportGroupNameMap = new Map();
        this.initializeDropdowmn();
        this.seDefaultValues();
    }
    seletDefaultReport() {
        if (this.reportGroup.value)
            this.getReport();
    }
    initializeDropdowmn() {
        this.getReportGroupSubscription =
            this.reportService.getReportGroup(+this.appController.selectedModuleID)
                .subscribe({
                next: (response) => {
                    this.reportList = response.value;
                    this.setReportGrouNames();
                    this.seletDefaultReport();
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(this.constructor.name, error, CRUDOperation.Get);
                }
            });
    }
    getReport() {
        this.reportListByGroupName = this.reportList.filter((g) => g.groupName.toLowerCase() === this.reportGroup.value.toLowerCase());
        // if(!this.reportId.value)
        this.reportId.setValue(this.reportListByGroupName[0].id);
        this.onSelectReport();
    }
    setReportGrouNames() {
        this.reportList.forEach((el) => {
            el.groupName = this.ucFirst.transform(el.groupName.toLowerCase());
        });
        this.reportList.sort((a, b) => (a.groupName > b.groupName ? 1 : -1));
        for (const element of this.reportList) {
            if (!this.reportGroupNameMap.has(element.groupName)) {
                this.reportGroupNameMap.set(element.groupName, element.groupName);
            }
        }
        this.reportList.forEach((el) => {
            el.name = this.ucFirst.transform(el.name.toLowerCase());
        });
        this.reportList.sort((a, b) => (a.name > b.name ? 1 : -1));
        this.changeDetectorRefs.detectChanges();
    }
    seDefaultValues() {
    }
    onSelectReport() {
        this.showing.emit(true);
        this.reportService.selectedReportEvent(this.reportId.value, this.reportGroup.value, this.reportListByGroupName);
    }
    static ctorParameters = () => [
        { type: FormBuilder },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: ReportService },
        { type: UcFirstPipe }
    ];
    static propDecorators = {
        reportTypeForm: [{ type: Input }],
        showing: [{ type: Output }]
    };
};
ReportTypeFormComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-report-type-form",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ReportTypeFormComponent);
export { ReportTypeFormComponent };
